import type { AccountDateRequest } from '~/composables/types/account-date-request'

export const accountDateRequestHasResponse = (
  dateRequest: AccountDateRequest
): boolean => (dateRequest.offerDates?.data?.length ?? 0) > 0

export const parseDateRequestOfferUrl = (offerUrl: string) => {
  try {
    const url = new URL(offerUrl)
    const match = url.pathname.match(/\/offer\/([^/]+)\/?/)

    if (!match?.[1]) {
      return null
    }

    return {
      id: match[1],
      signature: url.searchParams.get('signature') ?? '',
    }
  } catch {
    return null
  }
}

export const getDateRequestOfferPath = (dateRequest: AccountDateRequest) => {
  const parsedOffer = parseDateRequestOfferUrl(dateRequest.offer_url)

  if (!parsedOffer) {
    return null
  }

  return {
    path: `/offer/${parsedOffer.id}`,
    query: parsedOffer.signature ? { signature: parsedOffer.signature } : {},
  }
}
